import React from 'react'

const PlusIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="plusGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(100, 200, 255, 1)" />
          <stop offset="100%" stopColor="rgba(60, 160, 220, 1)" />
        </linearGradient>
        <filter id="plusGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Plus sign */}
      <line 
        x1="12" 
        y1="5" 
        x2="12" 
        y2="19" 
        stroke="url(#plusGradient)"
        strokeWidth="3"
        strokeLinecap="round"
        filter="url(#plusGlow)"
      />
      <line 
        x1="5" 
        y1="12" 
        x2="19" 
        y2="12" 
        stroke="url(#plusGradient)"
        strokeWidth="3"
        strokeLinecap="round"
        filter="url(#plusGlow)"
      />
    </svg>
  )
}

export default PlusIcon
